import Modal from '@gr-monorepo/common/ui/Modal';
import React, { useState } from 'react';
import styled, { css } from 'styled-components/macro';
import { ReactComponent as ArrowLeft } from './icons/arrow_left.svg';
import { ReactComponent as ArrowRight } from './icons/arrow_right.svg';
import { useClickStreamContext } from 'features/shared/ClickStream';

type Props = {
  images: string[];
  eventLogId: string;
};
const Img = styled.img`
  max-height: 150px;
  border: 4px solid #fff;
  border-radius: 8px;
  box-shadow: 0px 1px 6px -3px rgba(9, 21, 38, 0.85);
`;
const Wrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  ${Img} {
    margin: 0 16px 16px 0;
  }
  margin-bottom: -16px;
`;

const ModalWrap = styled.div`
  position: relative;
`;

const ModalImg = styled.img`
  max-width: calc(100vw - 200px);
  max-height: calc(100vh - 200px);
`;

export const Arrows = styled.div<{ Show?: boolean }>`
  position: absolute;
  top: 50%;
  width: 100%;
  transition: opacity 0.2s;
`;
export const Arrow = styled.div<{ Left?: boolean; Right?: boolean }>`
  width: 35px;
  height: 40px;
  background: #fff;
  position: absolute;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  z-index: 1;

  svg path {
    fill: rgba(9, 21, 38);
    fill-opacity: 0.6;
  }
  &:hover {
    svg path {
      fill-opacity: 0.85;
    }
  }
  ${({ Left }) =>
    Left &&
    css`
      justify-content: flex-start;
      left: 0;
      border-radius: 0px 100px 100px 0px;
      box-shadow: 5px 0px 13px -6px rgba(9, 21, 38, 0.35);
    `};
  ${({ Right }) =>
    Right &&
    css`
      justify-content: flex-end;
      right: 0;
      border-radius: 100px 0px 0px 100px;
      box-shadow: -5px 0px 13px -6px rgba(9, 21, 38, 0.35);
    `};
`;

const Gallery = (props: Props) => {
  const [currentImage, setCurrentImage] = useState<number | null>(null);
  const context = useClickStreamContext();
  return (
    <>
      <Wrap>
        {props.images.map((el, i) => (
          <Img
            src={el}
            onClick={() => {
              context.logPageEvent({
                eventInfo: 'Обновления кабмуна: клик по фото ' + props.eventLogId,
                eventType: 'cabmun_updates_click_on_image_' + props.eventLogId,
              });
              setCurrentImage(i);
            }}
          />
        ))}
      </Wrap>
      {currentImage !== null && (
        <Modal
          onClose={() => {
            context.logPageEvent({
              eventInfo: 'Обновления кабмуна: закрытие галереи ' + props.eventLogId,
              eventType: 'cabmun_updates_close_image_gallery_' + props.eventLogId,
            });
            setCurrentImage(null);
          }}
        >
          <ModalWrap>
            <ModalImg src={props.images[currentImage]} />
            {props.images.length > 1 && (
              <Arrows>
                {currentImage !== 0 && (
                  <Arrow
                    Left
                    onClick={() => {
                      context.logPageEvent({
                        eventInfo: 'Обновления кабмуна: пролистывание картинок ' + props.eventLogId,
                        eventType: 'cabmun_updates_swipe_image_' + props.eventLogId,
                      });
                      setCurrentImage(currentImage - 1);
                    }}
                  >
                    <ArrowLeft />
                  </Arrow>
                )}
                {currentImage !== props.images.length - 1 && (
                  <Arrow
                    Right
                    onClick={() => {
                      context.logPageEvent({
                        eventInfo: 'Обновления кабмуна: пролистывание картинок ' + props.eventLogId,
                        eventType: 'cabmun_updates_swipe_image_' + props.eventLogId,
                      });
                      setCurrentImage(currentImage + 1);
                    }}
                  >
                    <ArrowRight />
                  </Arrow>
                )}
              </Arrows>
            )}
          </ModalWrap>
        </Modal>
      )}
    </>
  );
};

export default Gallery;
